export interface ComponentWithChildren {
  children?: React.ReactNode | React.ReactNode[];
}

export enum DetailsPanelSize {
  XS = 'quarter',
  SMALL = 'third',
  MEDIUM = 'half',
  LARGE = 'twoThirds',
  XL = 'threeQuarters',
  FULL = 'full',
}

export type DefinitionDetails = ComponentWithChildren & {
  label: string;
};
